import { render, staticRenderFns } from "./EvidenceCard.vue?vue&type=template&id=6708b295&scoped=true&"
import script from "./EvidenceCard.vue?vue&type=script&lang=ts&"
export * from "./EvidenceCard.vue?vue&type=script&lang=ts&"
import style0 from "./EvidenceCard.vue?vue&type=style&index=0&id=6708b295&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6708b295",
  null
  
)

export default component.exports